import {cashBoxViewPage} from "../../../hoc/cashBoxViewPage";

const CashBoxTransfer = cashBoxViewPage("CashBoxTransfer")
export default CashBoxTransfer
